import React from "react"

function MapCenterDragMarker({ isDragging }: { isDragging: boolean }) {
  return <div className="map-marker-centered" style={{ display: isDragging ? "block" : "none" }}></div>
}

export default MapCenterDragMarker
